export function Floating({children, click, extend, style}){
    return (
        <div className={`floating ${extend ? 'extended' : ''}`} style={style} onClick={() => click()}>
            {
                children
            }
        </div>
    );
}